import { useLayoutEffect, useEffect, useRef, useCallback, useState } from 'react';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';

import Dashboard from './pages/MainApp/Dashboard/Dashboard';
import Templates from './pages/MainApp/Templates/Templates';
import Integrations from './pages/MainApp/Integrations/Integrations';
import TeamsAccess from './pages/MainApp/TeamsAccess/TeamsAccess';
import Subscriptions from './pages/MainApp/Subscriptions/Subscriptions';
import GuidesShortcuts from './pages/MainApp/GuidesShortcuts/GuidesShortcuts';
import SupportFeedback from './pages/MainApp/SupportFeedback/SupportFeedback';
import Settings from './pages/MainApp/Settings/Settings';

import Diagram from './pages/Diagram/Diagram';

import SignIn from './pages/Auth/SignIn';
import SignUp from './pages/Auth/SignUp';

import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';

import CheckEmail from './pages/Auth/CheckEmail/CheckEmail';
import EmailVerified from './pages/Auth/CheckEmail/EmailVerified';

import PasswordUpdated from './pages/Auth/CheckEmail/PasswordUpdated';

import Page404 from './pages/Auth/CheckEmail/Page404';
import PageError from './pages/Auth/CheckEmail/PageError';

import { selectThemeMode } from './redux/diagram/diagram.selectors';
import { selectAuthUser, selectAuthSessionStatus } from './redux/auth/auth.selectors';
import { checkUserSession } from "./redux/auth/auth.actions";

import LoaderLine from './components/Loaders/LoaderLine/LoaderLine';
import LoaderBar from './components/Loaders/LoaderBar/LoaderBar';

const App = () => {
    const history = useHistory();

    const { t, i18n } = useTranslation();

    const currentUser = useSelector(selectAuthUser);
    const sessionStatus = useSelector(selectAuthSessionStatus);

    // const isNotEmailVerified = false;//currentUser && !currentUser.emailVerified;
    // const isAuthorized = true;//currentUser && !isNotEmailVerified;

    const isNotEmailVerified = currentUser && !currentUser.emailVerified;
    const isAuthorized = currentUser && !isNotEmailVerified;

    const dispatch = useDispatch();
    const location = useLocation();
    const themeMode = useSelector(selectThemeMode);

    const isSessionChecked = useRef(false);

    useEffect(() => {
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    useLayoutEffect(() => {
        if (!isSessionChecked.current) {
            isSessionChecked.current = true;
            dispatch(checkUserSession());
        }
    }, [dispatch])

    useLayoutEffect(() => {
        const isNotEmailVerified = currentUser && !currentUser.emailVerified;
        if (isNotEmailVerified) {
            const url = `/check-email?email=${currentUser.email}`;
            setTimeout(() => { history.push(url); }, 300);
        }
    }, [currentUser])


    // const [isLoader, setIsLoader] = useState(false);

    // useEffect(() => {
    //     setIsLoader(true);
    //     setTimeout(() => { setIsLoader(false) }, 800);
    // }, [])


    if (!sessionStatus) {
        return <div></div>; // Покаже лоадер, поки перевіряється сесія
    }

    return (
        <div className={`App ${themeMode ? 'light-mode' : 'dark-mode'}`}>
            <Switch location={location} key={location.pathname}>

                {/* Dashboard Page */}
                <Route
                    // exact
                    path="/diagrams/"
                    render={() =>
                        isAuthorized
                            ? <Dashboard />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Templates Page */}
                <Route
                    // exact
                    path="/templates/"
                    render={() =>
                        isAuthorized
                            ? <Templates />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Integrations Page */}
                <Route
                    // exact
                    path="/integrations/"
                    render={() =>
                        isAuthorized
                            ? <Integrations />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Teams & Access Page */}
                {/* <Route
                    // exact
                    path="/teams-access/"
                    render={() =>
                        isAuthorized
                            ? <TeamsAccess />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                /> */}

                {/* Subscriptions Page */}
                <Route
                    // exact
                    path="/subscriptions/"
                    render={() =>
                        isAuthorized
                            ? <Subscriptions />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Guides & Shortcuts Page */}
                <Route
                    // exact
                    path="/guides-shortcuts/"
                    render={() =>
                        isAuthorized
                            ? <GuidesShortcuts />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Docs Page */}
                {/* <Route
                    // exact
                    path="/docs/"
                    render={() =>
                        isAuthorized
                            ? <Dashboard />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                /> */}

                {/* Invite Friends Page */}
                {/* <Route
                    // exact
                    path="/docs/"
                    render={() =>
                        isAuthorized
                            ? <Dashboard />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                /> */}

                {/* Upgrade Plan Page */}
                {/* <Route
                    // exact
                    path="/upgrade/"
                    render={() =>
                        isAuthorized
                            ? <Dashboard />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                /> */}

                {/* Support & Feedback */}
                <Route
                    // exact
                    path="/support-feedback/"
                    render={() =>
                        isAuthorized
                            ? <SupportFeedback />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Settings */}
                <Route
                    // exact
                    path="/settings/"
                    render={() =>
                        isAuthorized
                            ? <Settings />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />


                {/* Diagram Page */}
                <Route
                    exact
                    path="/diagram/:diagramId"
                    // render={() => isAuthorized ? <Diagram /> : <Redirect to={{ pathname: '/sign-in/', state: { from: location } }} />}
                    render={() =>
                        isAuthorized
                            ? <Diagram />
                            : isNotEmailVerified
                                ? <Redirect to={`/check-email?email=${currentUser.email}`} />
                                : <Redirect to="/sign-in/" />
                    }
                />

                {/* Document Page */}
                {/* <Route path="/document/:documentId/" component={Document}></Route> */}

                {/* Subscriptions Page */}
                {/* <Route exact path="/subscriptions/" component={Subscriptions}></Route> */}

                {/* Account Page */}
                {/* <Route exact path="/account" component={Subscriptions}></Route> */}
                {/* <Route exact path="/profile" component={Subscriptions}></Route> */}
                {/* <Route exact path="/me" component={Subscriptions}></Route> */}

                {/* Auth Pages */}
                <Route
                    exact
                    path="/sign-in"
                    // render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <SignIn />}
                    component={SignIn}
                />
                <Route
                    exact
                    path="/sign-up"
                    // render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <SignUp />}
                    render={() =>
                        // isAuthorized
                        //     ? <Redirect to="/diagrams/" />
                        //     : <SignUp />
                        <SignUp />
                    }
                />
                <Route
                    exact
                    path="/forgot-password"
                    render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <ForgotPassword />}
                />

                <Route
                    exact
                    path="/reset-password"
                    render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <ResetPassword />}
                />

                <Route
                    exact
                    path="/check-email"
                    component={CheckEmail}
                // render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <SignUp />}
                />

                <Route
                    exact
                    path="/email-verified"
                    component={EmailVerified}
                // render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <SignUp />}
                />

                <Route
                    exact
                    path="/password-updated"
                    component={PasswordUpdated}
                // render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <SignUp />}
                />

                <Route
                    exact
                    path="/error"
                    component={PageError}
                // render={() => isAuthorized ? <Redirect to="/diagrams/" /> : <SignUp />}
                />

                <Route
                    exact
                    path="/">
                    <Redirect to="/diagrams/" />
                </Route>

                <Route
                    exact
                    path="/dashboard">
                    <Redirect to="/diagrams/" />
                </Route>

                {/* 404 Page Redirect */}
                <Route
                    path="/*"
                    component={Page404}
                />
            </Switch>
        </div>
    );
};

export default App;
